import React, { useState, useRef } from 'react';
import {
  CuentaDNI,
  HomeBanking,
  Cajero,
  Administra,
  Calendario,
  Seguridad1,
  Contacto1
} from 'components/articles';
import Button from 'components/ui/button';

import image from 'assets/images/main-mayores.jpg';


export default function Mas60() {
  const inputRef = useRef(null);
  const [article, setArticle] = useState("");
  const variant = "mayores";

  const selectArticle = item => {
    setArticle(item);
    const scrollto = inputRef.current.getBoundingClientRect().top + window.scrollY - 150;
    window.scrollTo({ top: scrollto, behavior: 'smooth' });
  }
  
  return (
    <div className={`wrapper ${variant}`}>
      <div className="content-cols">
        <figure>
          <img src={image} alt="¿Tenés más de 60 años?" />
          <figcaption>¿Tenés más<br />de 60 años?</figcaption>
        </figure>
        <section className='segment-nav'>
          <Button
            article='cuenta-dni'
            active={article === 'cuenta-dni'}
            onclick={() => selectArticle('cuenta-dni')}
          />
          <Button
            article='homebanking'
            active={article === 'homebanking'}
            onclick={() => selectArticle('homebanking')}
          />
          <Button
            article='cajero'
            active={article === 'cajero'}
            onclick={() => selectArticle('cajero')}
          />
          <Button
            article='administra'
            active={article === 'administra'}
            onclick={() => selectArticle('administra')}
          />
          <Button
            article='calendario'
            active={article === 'calendario'}
            onclick={() => selectArticle('calendario')}
          />
          <Button
            article='seguridad'
            active={article === 'seguridad'}
            onclick={() => selectArticle('seguridad')}
          />
          <Button
            article='contacto'
            active={article === 'contacto'}
            onclick={() => selectArticle('contacto')}
          />
        </section>
      </div>
      <div ref={inputRef}>
        {article &&
          <article>
            {article === 'cuenta-dni' && <CuentaDNI variant={variant} />}
            {article === 'homebanking' && <HomeBanking />}
            {article === 'cajero' && <Cajero />}
            {article === 'administra' && <Administra variant={variant} />}
            {article === 'calendario' && <Calendario variant={1} />}
            {article === 'seguridad' && <Seguridad1 variant={variant} />}
            {article === 'contacto' && <Contacto1 />}
          </article>
        }
      </div>
    </div>
  );
}